import React, { useEffect } from "react";
import { DatePicker, Space } from "antd";
import { connect } from "react-redux";
import moment from "moment";
import { setEditDateOfBirth } from "actions/userManagement";
// import { setInstallments } from "actions/course";

function StartDate_Picker({
  setInstallments,
  installments,
  index,
  value,
  //   setCourseStartDate,
  setInstCust,
  price,
  setCourseStartDate,
}) {
  function onChange(date, dateString) {
    // console.log("start date", dateString);
    if (
      moment(dateString, "DD-MM-YYYY").format("YYYY-MM-DD") !== "Invalid date"
    ) {
      // console.log(
      //   "start date",
      //   moment(dateString, "DD-MM-YYYY").format("YYYY-MM-DD")
      // );
      setCourseStartDate(moment(dateString, "DD-MM-YYYY").format("YYYY-MM-DD"));
    } else {
    }

    // setInstallments([...installments]);
  }
  function disabledDate(current) {
    // Can not select days before today and today
    // if (installments?.length) {
    //   return current > installments[index - 1] ? true : false;
    // console.log(
    //   "datepic",
    //   !(current && current > moment()),
    //   moment() < current,
    //   current < moment().add(10, "days")
    //   // current
    // );
    // }
    // return !(current && current > moment());
  }

  return (
    <Space direction="vertical" style={{ width: "100%" }} size={50}>
      <DatePicker
        allowClear={false}
        className="datePicker"
        onChange={onChange}
        value={
          value !== null
            ? moment(
                moment(value, "YYYY-MM-DD").format("DD-MM-YYYY"),
                "DD-MM-YYYY"
              )
            : ""
        }
        placeholder={["Select a date"]}
        style={{ width: "100%" }}
        format={"DD-MM-YYYY"}
        disabledDate={disabledDate}
      />
    </Space>
  );
}

// export default Date_Picker1
const mapStateToProps = (state) => {
  const {} = state.course;
  return {};
};

const mapDispatchToProps = (dispatch) => ({
  setEditDateOfBirth: (date) => dispatch(setEditDateOfBirth(date)),
  // setInstallments: (val) => dispatch(setInstallments(val)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StartDate_Picker);
